import { module } from 'angular';

export const WHATS_NEW_MODULE = 'spinnaker.core.whatsNew';
module(WHATS_NEW_MODULE, [
  require('./whatsNew.directive').name,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/whatsNew/whatsNew.module.ts